// extracted by mini-css-extract-plugin
module.exports = {"fixed-nav":"header_fixed-nav__BtJPr","fixed-nav-stuck":"header_fixed-nav-stuck__Q_uLH"};